import { render, staticRenderFns } from "./MdFile.vue?vue&type=template&id=371e940e"
import script from "./MdFile.vue?vue&type=script&lang=js"
export * from "./MdFile.vue?vue&type=script&lang=js"
import style0 from "./MdFile.vue?vue&type=style&index=0&id=371e940e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports